export interface SelectOption {
  value: string;
  label: string;
}

export interface LogoSettings {
  hasLogo: boolean;
  logoUrl: string | null;
  logoPosition: string;
  logoSize: string;
  logoFile: File | null;
}

export interface HeaderSettings {
  companyName: string;
  headerText: string;
  showDate: boolean;
  showPeriod: boolean;
  headerColor: string;
  headerBackgroundColor: string;
}

export interface FooterSettings {
  footerText: string;
  includeDisclaimer: boolean;
  disclaimerText: string;
  showHelpContact: boolean;
  helpContact: string;
  footerColor: string;
}

export interface LayoutSettings {
  template: string;
  colorScheme: string;
  fontSize: string;
  showCompanyAddress: boolean;
  showEmployeePhoto: boolean;
  paperSize: string;
  margins: string;
}

export interface Customization {
  primaryColor: string;
  accentColor: string;
  fontFamily: string;
  borderStyle: string;
  showWatermark: boolean;
  watermarkText: string;
}

export interface BrandingSettings {
  enableBranding: boolean;
  logoSettings: LogoSettings;
  headerSettings: HeaderSettings;
  footerSettings: FooterSettings;
  layoutSettings: LayoutSettings;
  customization: Customization;
}

export const DEFAULT_BRANDING_SETTINGS: BrandingSettings = {
  enableBranding: true,
  logoSettings: {
    hasLogo: false,
    logoUrl: null,
    logoPosition: 'top-left',
    logoSize: 'medium',
    logoFile: null,
  },
  headerSettings: {
    companyName: 'Company Name LLC',
    headerText: 'Monthly Payslip',
    showDate: true,
    showPeriod: true,
    headerColor: '#1f2937',
    headerBackgroundColor: '#f9fafb',
  },
  footerSettings: {
    footerText: 'This is an official document generated by the payroll system.',
    includeDisclaimer: true,
    disclaimerText: 'This document is confidential and intended for the addressee only.',
    showHelpContact: true,
    helpContact: 'hr@company.com',
    footerColor: '#6b7280',
  },
  layoutSettings: {
    template: 'standard',
    colorScheme: 'professional',
    fontSize: 'medium',
    showCompanyAddress: true,
    showEmployeePhoto: false,
    paperSize: 'A4',
    margins: 'normal',
  },
  customization: {
    primaryColor: '#2563eb',
    accentColor: '#059669',
    fontFamily: 'Inter',
    borderStyle: 'subtle',
    showWatermark: false,
    watermarkText: 'CONFIDENTIAL',
  },
};

/** Select option lists used across sub-components */
export const LOGO_POSITION_OPTIONS: SelectOption[] = [
  { value: 'top-left', label: 'Top Left' },
  { value: 'top-center', label: 'Top Center' },
  { value: 'top-right', label: 'Top Right' },
  { value: 'header-left', label: 'Header Left' },
  { value: 'header-right', label: 'Header Right' },
];

export const LOGO_SIZE_OPTIONS: SelectOption[] = [
  { value: 'small', label: 'Small (50px)' },
  { value: 'medium', label: 'Medium (80px)' },
  { value: 'large', label: 'Large (120px)' },
  { value: 'custom', label: 'Custom Size' },
];
